import src from "IMAGE";
export default { src, width: 181, height: 27, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AKAQA4dYCAFJhw0CcqwRA5OTLSR9k4mIfIiIiG+wsbGXpiQMcYWRhJQAAAAASUVORK5CYII="};
